/**
 * One content column for the Scout Central home page, so the header, the agent grid and the bottom
 * row line up as a single workspace instead of three bands of different widths.
 */
export const SCOUT_CONTAINER = 'max-w-[1240px] mx-auto px-4 sm:px-6 lg:px-10';
